// extracted by mini-css-extract-plugin
module.exports = {"Content":"rightSide_Content__kTuJ8","Side":"rightSide_Side__zYpi1","Block":"rightSide_Block__oMfm1"};